export default __webpack_public_path__ + "static/media/steyr-4100-multi-ecotech.9b6ecb40.jpg";